<template>
  <div>
    <LayoutSection size="o5v90" class="p-30">
      <div class="forgot-password">
        <div class="forgot-password-content">
          <h1 class="text-left text-uppercase mt-50 mb-50 text-center">
            {{ $t("users.forgotPassword.title") }}
          </h1>
        </div>
        <el-row>
          <el-col :xs="6" :md="6" :sm="6" class="forgot-form">
            <el-form>
              <el-form-item prop="password" class="mb-5">
                <el-input
                  id="password"
                  class="show-password"
                  v-model="forgotPassword"
                  show-password
                  :placeholder="$t('users.forgotPassword.placeHolder')"
                />
              </el-form-item>
              <el-button
                type="primary"
                native-type="submit"
                class="ctaSubmit mt-5 mb-100"
              >
                {{ $t("users.forgotPassword.button") }}
              </el-button>
            </el-form>
          </el-col>
          <el-col :md="18" class="description">
            <hr />
            <p class="mt-10 text-center mb-100">
              {{ $t("users.forgotPassword.text") }}
            </p>
          </el-col>
        </el-row>
      </div>
    </LayoutSection>
  </div>
</template>

<script>
import layoutUtils from "@/utils/layout-utils";
import LayoutSection from "@/components/layout/layout-section.vue";

export default {
  components: {
    LayoutSection,
  },
  props: {
    slug: {
      type: String,
      default: null,
    },
    puid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      forgotPassword: "",
    };
  },
  computed: {
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    address3Title() {
      return this.$i18n.t("aboutUs.address3.title");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
$logo-dimension: 16px;
.about-container-main {
  margin: 0 100px;
  // sm -
  @media screen and (max-width: $media-md) {
    margin: 0 20px;
  }
}
.forgot-form {
  float: none;
  margin: auto;
}
.ctaSubmit {
  width: 150px;
  height: 35px;
}
.description {
  float: none;
  margin: auto;
}
</style>
